import { WHBABTEC_ENVIRONMENT } from '@whbabtec-environment';

const BASE_URL = WHBABTEC_ENVIRONMENT.api.baseUrl;

export const WHBABTEC_DEBOUNCE_TIME = 300;

export type WhbabtecEndpoints = {
  AUTOCOMPLETE: string;
  PRODUCT: string;
  COMPLAINT_CREATE: string;
  COMPLAINT_OVERVIEW: string;
  FILE: string;
  USER: string;
};

export const WHBABTEC_ENDPOINTS: WhbabtecEndpoints = {
  AUTOCOMPLETE: `${BASE_URL}/api/v1/babtec/autocomplete`,
  PRODUCT: `${BASE_URL}/api/v1/babtec/products`,
  COMPLAINT_CREATE: `${BASE_URL}/api/v1/complaint`,
  COMPLAINT_OVERVIEW: `${BASE_URL}/api/v1/complaint/status`,
  FILE: `${BASE_URL}/api/v1/complaint/file`,
  USER: `${BASE_URL}/api/v1/users`,
};
